export default __webpack_public_path__ + "static/media/regulatory--stop--g2.483334d1.png";